import * as C from '../constants';
import helpers from './helpers';
import coreService from '../../../services/core-service';
import giftVoucherService from '../../../services/gift-voucher-service';

export default {
  loadDomains({ commit, rootState }) {
    commit(C.GIFT_VOUCHER_DOMAINS_PENDING);
    const brandIds = rootState.app.auth.brands.map(brand => brand.id);
    coreService.getDomainsByBrandIds(brandIds)
      .then((response) => {
        if (response.status === 200) {
          commit(C.GIFT_VOUCHER_DOMAINS_SUCCESS, response.data);
        } else {
          commit(C.GIFT_VOUCHER_DOMAINS_FAILURE);
        }
      })
      .catch(() => {
        commit(C.GIFT_VOUCHER_DOMAINS_FAILURE);
      });
  },
  searchBookingList({ commit }, request) {
    commit(C.GIFT_VOUCHER_BOOKING_LIST_SEARCH_PENDING);
    return giftVoucherService.searchBookingList(request)
      .then((response) => {
        if (response.status === 200) {
          commit(C.GIFT_VOUCHER_BOOKING_LIST_SEARCH_SUCCESS, response.data);
        } else {
          commit(C.GIFT_VOUCHER_BOOKING_LIST_SEARCH_NO_CONTENT);
        }
      })
      .catch(() => {
        commit(C.GIFT_VOUCHER_BOOKING_LIST_SEARCH_FAILURE);
      });
  },
  mailBookings({ commit }, bookingIds) {
    commit(C.GIFT_VOUCHER_BOOKING_LIST_SEND_PENDING);
    return giftVoucherService.sendMails(bookingIds)
      .then((response) => {
        if (response.status === 204) {
          commit(C.GIFT_VOUCHER_BOOKING_LIST_SEND_SUCCESS);
        } else {
          commit(C.GIFT_VOUCHER_BOOKING_LIST_SEND_FAILURE);
        }
      })
      .catch(() => {
        commit(C.GIFT_VOUCHER_BOOKING_LIST_SEND_FAILURE);
      });
  },
  searchEmailList({ commit }, domain) {
    commit(C.GIFT_VOUCHER_EMAIL_LIST_SEARCH_PENDING);
    return giftVoucherService.searchEmailList(domain)
      .then((response) => {
        if (response.status === 200) {
          const bookings = response.data;
          Object.keys(bookings).forEach((index) => {
            bookings[index].status = helpers.getBookingStatus(bookings[index].status);
          });
          commit(C.GIFT_VOUCHER_EMAIL_LIST_SEARCH_SUCCESS, bookings);
        } else {
          commit(C.GIFT_VOUCHER_EMAIL_LIST_SEARCH_NO_CONTENT);
        }
      })
      .catch(() => {
        commit(C.GIFT_VOUCHER_EMAIL_LIST_SEARCH_FAILURE);
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/giftVoucher/actions.js